import Button from "@imminently/decisively-ui/Button";
import Icon from "@imminently/decisively-ui/Icon";
import { ToastContainer, type Theme, type ToastContainerProps, type TypeOptions } from "react-toastify";
import styles from "./AppToasts.module.scss";

type ToastCloseButtonProps = {
  closeToast: (event: React.MouseEvent<HTMLElement>) => void;
  type: TypeOptions;
  ariaLabel?: string;
  theme: Theme;
};

const ToastCloseButton = ({ closeToast, ariaLabel }: ToastCloseButtonProps) => (
  <Button
    icon
    variant="ghost"
    label={ariaLabel ?? "Close notification"}
    tooltip={false}
    className={styles.closeButton}
    onClick={closeToast}
  >
    <Icon name="clear" />
  </Button>
);

const AppToasts = (props: ToastContainerProps) => (
  <ToastContainer
    closeButton={ToastCloseButton}
    toastClassName={styles.toast}
    bodyClassName={styles.body}
    progressClassName={styles.progress}
    className={styles.container}
    {...props}
  />
);

export default AppToasts;
